import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { stringifyJsonLd } from 'bundles/seo/utils/utils';
import {
  getBreadcrumbListMarkupData,
  getCredentialCategoryMarkupData,
  getProviderMarkupData,
} from 'bundles/xddp/utils/schema-markup';

type Props = {
  pageContent: any;
};

type SchemaMarkupObj = {
  '@context': string;
  '@graph': unknown[];
};

class AdmissionsPageSchemaMarkup extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof AdmissionsPageSchemaMarkup.contextTypes>;

  generateSchemaMarkupObj = (): SchemaMarkupObj => {
    const { pageContent } = this.props;
    const { router } = this.context;

    const breadcrumbMarkup = getBreadcrumbListMarkupData(pageContent, {
      pageName: 'Admissions',
      pathName: router.location.pathname,
    });
    const credentialCategoryMarkup = getCredentialCategoryMarkupData(pageContent);
    const providerMarkup = getProviderMarkupData(pageContent);

    return {
      '@context': 'http://schema.org',
      '@graph': [
        breadcrumbMarkup,
        {
          '@id': `https://www.coursera.org/degrees/${pageContent.slug}#degree`,
          '@type': 'Course',
          name: pageContent.programName,
          url: `https://www.coursera.org/degrees/${pageContent.slug}`,
          image: pageContent?.partnerInformation?.partnerLogo,
          description: pageContent.seoDescription,
          educationalCredentialAwarded: {
            '@type': 'EducationalOccupationalCredential',
            credentialCategory: credentialCategoryMarkup,
          },
          hasCourseInstance: {
            '@type': 'CourseInstance',
            name: pageContent.seoTitle,
            courseMode: ['distance learning', 'online'],
            startDate: '2019-08-26T00:00:00.000Z',
            location: {
              '@type': 'Place',
              name: 'Online',
              address: 'Online',
            },
          },
          provider: providerMarkup,
        },
      ],
    };
  };

  createMarkup = () => {
    const markupObject = this.generateSchemaMarkupObj();

    return {
      __html: `
        <script type="application/ld+json">
          ${stringifyJsonLd(markupObject)}
        </script>
      `,
    };
  };

  render() {
    const markUp = this.createMarkup();

    return (
      <div className="rc-DegreeGoogleSchemaMarkup">
        {/* eslint-disable react/no-danger */}
        <div dangerouslySetInnerHTML={markUp} />
      </div>
    );
  }
}

export default AdmissionsPageSchemaMarkup;
